"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textLabel = exports.absFull = exports.contentCentered = exports.placeholder = void 0;

var _styledComponents = require("styled-components");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 10px;\n  line-height: 14px;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  bottom: ", ";\n  left: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  white-space: nowrap;\n  -moz-user-select: -moz-none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n\n  & > * {\n    display: inline-block;\n    vertical-align: middle;\n    position: relative;\n    white-space: normal;\n    -moz-user-select: text;\n    -webkit-user-select: text;\n    -ms-user-select: text;\n  }\n\n  &:before {\n    content: '';\n    height: 100%;\n    margin: 0 -0.1em;\n    display: inline-block;\n    vertical-align: middle;\n    -moz-user-select: -moz-none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &::-webkit-input-placeholder {\n    ", "\n  }\n\n  &:-moz-placeholder {\n    ", "\n  }\n\n  &::-moz-placeholder {\n    ", "\n  }\n\n  &:-ms-input-placeholder {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var placeholder = function placeholder(rules) {
  return (0, _styledComponents.css)(_templateObject(), rules, rules, rules, rules);
};

exports.placeholder = placeholder;
var contentCentered = (0, _styledComponents.css)(_templateObject2());
exports.contentCentered = contentCentered;

var absFull = function absFull() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return (0, _styledComponents.css)(_templateObject3(), t, r, b, l);
};

exports.absFull = absFull;

var textLabel = function textLabel() {
  return (0, _styledComponents.css)(_templateObject4());
};

exports.textLabel = textLabel;

//# sourceMappingURL=styled.js.map